import { HttpClient } from "@angular/common/http";
import { catchError, map } from "rxjs/operators";
import { API_ADDRESS, httpOptionsDefault } from "../constants";
import { Company } from "../models/company.model";

export class BuyController {

  getCustomer(_key: any) {
    throw new Error('Method not implemented.');
  }
 
  
 

    private _controllerName: string;
 
    constructor(public _http: HttpClient) {

        this._controllerName = "buy";
    } 
    

    getCriptoKey(key: string) {


        key = encodeURI(key);

        let address = API_ADDRESS + `/${this._controllerName }/criptoKey/${key}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
  
    }

    
    verifyCustomer(identifier: string) {


        identifier = encodeURI(identifier);

        let address = API_ADDRESS + `/${this._controllerName }/verify/${identifier}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
  
    }

    verifyLicenseKey(licenseKey) {
     
        let address = API_ADDRESS + `/${this._controllerName }/verifyLicenseKey/${licenseKey}`;
    
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {
    
                    return result;
                }
    
                ),
                catchError(error => {
    
                    return error;
                })
            )
            .toPromise().then((result: any) => {
    
                return result;
            });
      }
 
      
      getPurchaseData(key: any) {
        let address = API_ADDRESS + `/${this._controllerName }/purchase/${key}`;
    
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {
    
                    return result;
                }
    
                ),
                catchError(error => {
    
                    return error;
                })
            )
            .toPromise().then((result: any) => {
    
                return result;
            });
      }
  
      
    addOrder(order) {
        let address = API_ADDRESS + `/${this._controllerName }/newOrder`;

     
        return this._http.post(address,order,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }

      

      getFinancialTransaction(financialTransactionId: any) {

     
        let address = API_ADDRESS + `/${this._controllerName }/financialTransactions/${financialTransactionId}`;

   
        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }

      
      getPaymentTypes(key) {


        key = encodeURI(key);

        let address = API_ADDRESS + `/${this._controllerName }/paymentTypes/${key}`;

        console.log(address);

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }

      public  sendCustomerData(key, data) {


        key = encodeURI(key);

        let address = API_ADDRESS + `/${this._controllerName }/sendCustomerData/${key}`;

       

        return this._http.post(address,data,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }


      public  getCustomerData(key) {


        key = encodeURI(key);

        let address = API_ADDRESS + `/${this._controllerName }/customerData/${key}`;

       

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }


     public  getPresaleData(key) {


        key = encodeURI(key);

        let address = API_ADDRESS + `/${this._controllerName }/presaleData/${key}`;

       

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }

      getConfirmation(key: any) {

        key = encodeURI(key);

        let address = API_ADDRESS + `/${this._controllerName }/confirmation/${key}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }
 
      
   
      getProductsSuperLicense(productId: number) {
          
        let address = API_ADDRESS + `/${this._controllerName }/productsSuperLicense/${productId}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
    }
      
      
    getProductsSameCategory(productId: number) {
       
        
        let address = API_ADDRESS + `/${this._controllerName }/productsSameCategory/${productId}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
    }
      
    getProductCategory(productId: number) {
       
        
        let address = API_ADDRESS + `/${this._controllerName }/productCategory/${productId}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result => {

                    return result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
    }

      
    generateValidationCode(email: any,companyId: any) {

        email = encodeURI(email);

        let address = API_ADDRESS + `/${this._controllerName }/validationCode/${companyId}/${email}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result=> {

                 
                    return  result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }


    getCompanyData(companyId: number):Promise<Company> {
        let address = API_ADDRESS + `/${this._controllerName }/companyData/${companyId}`;

        return this._http.get(address,  httpOptionsDefault)
            .pipe(
                map(result=> {

                 
                    return  result;
                }

                ),
                catchError(error => {

                    return error;
                })
            )
            .toPromise().then((result: any) => {

                return result;
            });
      }
  
      
}